import React, { useState } from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import UIUtils from "utils/UIUtils";
function ContentsContainer() {

	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();

	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count
	 
	/** 검색조건 */
	const [searchText,setSearchText] = useState('');
	const [searchDivCd,setSearchDivCd] = useState('01');

	//초기 데이터 설정
	let totalCnt:number = 0;
	let LeftSheetData = {};
	let RightSheetData = {};

	// @ts-ignore
	let limitItems:{PERSON_ID:string;LIMIT_AMOUNT:string;AMOUNT_RANGE:string; LIST_ORDER:string; ROW_STATUS:string}[] = [];		
	// @ts-ignore
	let limitItem: {PERSON_ID:string;LIMIT_AMOUNT:string;AMOUNT_RANGE:string; LIST_ORDER:string; ROW_STATUS:string } = {};
	

	var ib = ib||{};
	ib = {
	//시트 초기화 구문
	'init':{
	"LeftSheetInit": {
		//공통기능 설정 부분
	    "Cfg": {
		"CanDrag": 0
		},
		//중앙(메인) 컬럼 설정
	    "Cols": [
			{"Header": "ID","Type": "Text","Name": "PERSON_ID","MinWidth": 50,"Align": "Center","CanEdit": 0,"RelWidth": 1, "Hidden" : 1},
			{"Header": "성명","Type": "Text","Name": "PERSON_NM","MinWidth": 50,"Align": "Center","CanEdit": 0,"RelWidth": 1},
			{"Header": "직급","Type": "Text","Name": "POSI_NM","MinWidth": 60,"Align": "Center","CanEdit": 0,"RelWidth": 1},
			{"Header": "부서","Type": "Text","Name": "DEPT_NM","MinWidth": 40,"Align": "Center","CanEdit": 0,"RelWidth": 1},
			{"Header": "아이디","Type": "Text","Name": "LOGIN_NM","MinWidth": 50,"Align": "Center","CanEdit": 0,"RelWidth": 1}
		]
	},
	"RightSheetInit": {
		"Cfg": {
		"SearchMode": 2,
		"CanDrag": 0
		},
		"Cols": [
			{"Header": "ID","Type": "Text","Name": "PERSON_ID","MinWidth": 50,"Align": "Center","CanEdit": 0,"RelWidth": 1, "Hidden" : 1},
			{"Header": "성명","Type": "Text","Name": "PERSON_NM","MinWidth": 50,"Align": "Center","CanEdit": 0,"RelWidth": 1},
			{"Header": "직급","Type": "Text","Name": "POSI_NM","MinWidth": 60,"Align": "Center","CanEdit": 0,"RelWidth": 1},
			{"Header": "부서","Type": "Text","Name": "DEPT_NM","MinWidth": 40,"Align": "Center","CanEdit": 0,"RelWidth": 1},
			{"Header": "아이디","Type": "Text","Name": "LOGIN_NM","MinWidth": 50,"Align": "Center","CanEdit": 0,"RelWidth": 1},
			{"Header": {"Value": "한도금액" ,"Color": "#FFDFDF"},"Required": 1.5,"Type": "Float","Name": "LIMIT_AMOUNT","MinWidth": 50,"RelWidth": 1,"Align": "Right","CanEdit": 1,"Format": "#,###"},
			{"Header": {"Value": "범위" ,"Color": "#FFDFDF"},"Type": "Enum","Name": "AMOUNT_RANGE","Required": 1,"RelWidth": 1,"CanEdit": 1,"Enum": "|이상|미만","EnumKeys": "|1|2"}
		]
	}
	},
	//시트 이벤트
	'event':{
		onAfterRowMoveToSheet:function (evtParam) {
			//console.log('onAfterRowMoveToSheet 이벤트 발생:\n' + evtParam.sheet.id + '시트에서 ' + evtParam.tosheet.id + '로 행이 이동하였습니다.');
		},
		onRenderFirstFinish:function (evtParam) {
				//@ts-ignore
				LeftSheet.hideCol( "PERSON_ID" );   //사용자ID컬럼 숨김처리
				//@ts-ignore
				RightSheet.hideCol( "PERSON_ID" );  //사용자ID컬럼 숨김처리

				//초기 데이터 로딩
				doSearchLeft('init');  //왼쪽탭 전체목록
				doSearchRight();       //오른쪽 한도금액통제 저장 목록
			
		},
		onAfterRowCopy:function(evtParam){
			if(evtParam.source.Deleted === true) {
				UIUtils.alert('지워진 행은 복사할 수 없습니다.').then();
				return true;
			}
		},
		onDblClick:function(evtParam){     //더블 클릭시 행 카피 가능하게 처리
			var sheet = evtParam.sheet;
			if(sheet.id === "LeftSheet"){     //왼쪽 시트일경우만 copy가능
				/** 행 추가 전에 중복 데이터 확인 처리 */
				//@ts-ignore
				if(RightSheet.getTotalRowCount() > 0){
					//@ts-ignore
					var rightRows = RightSheet.getDataRows(); //우측 시트값 전체 데이터 조회
					//@ts-ignore
					var fRows = LeftSheet.getFocusedRow();   //좌측 시트값 체크
					for(var i=0; i<rightRows.length; i++){
						if(fRows.PERSON_NM === rightRows[i].PERSON_NM){
							UIUtils.alert(rightRows[i].PERSON_NM + ' 이름이 존재합니다.').then();
							return;
						}
					}
				}
				//@ts-ignore
				RightSheet.copyRow({row: LeftSheet.getFocusedRow()});
				//@ts-ignore
				RightSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
			}
		},
		
	},
	//시트객체 생성
	'create':function () {
		var options = this.init.LeftSheetInit;

		options.Events = this.event;
		//@ts-ignore
		IBSheet.create({
			id: 'LeftSheet', // 생성할 시트의 id
			el: 'LeftSheetDiv', // 시트를 생성할 Dom 객체 및 id
			options: options, // 생성될 시트의 속성
			data: LeftSheetData // 생성될 시트의 정적데이터
		});

		var options2 = this.init.RightSheetInit;
		options2.Events = this.event;
		//@ts-ignore
		IBSheet.create({
			id: 'RightSheet', // 생성할 시트의 id
			el: 'RightSheetDiv', // 시트를 생성할 Dom 객체 및 id
			options: options2, // 생성될 시트의 속성
			data: RightSheetData // 생성될 시트의 정적데이터
		});
	},
	//조회 데이터
	'data':{}
	
    }

	//====== 왼쪽탭 사용자 전체 리스트 그리드 데이터 가지고 오기  START
	async function doSearchLeft(sAction:string) {
		let param = {};
		if(sAction =='search'){
			param = {
				"SEARCH_DIV_CD": searchDivCd,
				"SEARCH_TEXT": searchText,
			};
		}
		
		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'adm_4310',
			data: param
		})

		//전체데이터 
		let result = response.REC;

		if(result != null){
			//전체데이터 
			let result = response.REC;
			//전체ROW개수 
			totalCnt = Object.keys(result).length;
			setTotalRowCnt(Object.keys(result).length);
		}
		
	   //데이터 처리
	   LeftSheetData = result;
	   // @ts-ignore	
	   LeftSheet.loadSearchData(result);  //data 로딩 처리 
	   // @ts-ignore	
	   LeftSheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	   // @ts-ignore	
	  //makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화
		
    }
	//====== 그리드 데이터 가지고 오기  END

	//====== 왼쪽탭 사용자 전체 리스트 그리드 데이터 가지고 오기  START
	async function doSearchRight() {
		let param = {};
		
		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'adm_4310_limitlist',
			data: param
		})

		//전체데이터 
		let result = response.REC;

		if(result != null){
			//전체ROW개수 
			totalCnt = Object.keys(result).length;
			setTotalRowCnt(Object.keys(result).length);
		}
		
	   //데이터 처리
	   RightSheetData = result;
	   // @ts-ignore	
	   RightSheet.loadSearchData(result);  //data 로딩 처리 
	   // @ts-ignore	
	   RightSheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함		
    }
	//====== 그리드 데이터 가지고 오기  END

	//검색조건 선택
	const handleSelect = (e) => {
		if(e.target.name === 'divCd'){
			setSearchDivCd(e.target.value);
	    }
	};

	//인풋 엔터체크
	const activeEnter = (e) => {
		if(e.key === "Enter") {
			doSearchLeft('search');
		}
	}

	//행 추가
	const rowAdd = (e) => {
		/** 행 추가 전에 중복 데이터 확인 처리 */
		//@ts-ignore
		if(RightSheet.getTotalRowCount() > 0){
			//@ts-ignore
			var rightRows = RightSheet.getDataRows(); //우측 시트값 전체 데이터 조회
			//@ts-ignore
            var fRows = LeftSheet.getFocusedRow();   //좌측 시트값 체크
			for(var i=0; i<rightRows.length; i++){
				if(fRows.PERSON_NM === rightRows[i].PERSON_NM){
					UIUtils.alert(rightRows[i].PERSON_NM + ' 이름이 존재합니다.').then();
					return;
				}
			}
		}
		//@ts-ignore
		RightSheet.copyRow({row: LeftSheet.getFocusedRow()});
		//@ts-ignore
		RightSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
	} 

	// 행 삭제
	const rowDel = (e) => {
        //@ts-ignore
		//RightSheet.removeRow({row:RightSheet.getFocusedRow()});
		RightSheet.deleteRow(RightSheet.getFocusedRow(), 1, 0, 0);
		
		//@ts-ignore
		RightSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
		
	} 

	//결재자 위로
	const rowMoveUp = (e) => {

		// 선택된 행 객체를 얻음.
		//@ts-ignore
		var crow = RightSheet.getFocusedRow();
		if (crow) {
			//@ts-ignore
			var nrow = RightSheet.getPrevRow(crow);
			// index 기준 Row객체 얻기
			if(nrow != null){
				//@ts-ignore
				RightSheet.moveRow({row:crow, next:nrow , render:1});
				//@ts-ignore
				RightSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
			}
		}else{
			UIUtils.alert('선택된 셀이 없습니다.').then();
		}
	}

	//결재자 아래로
	const rowMoveDown = (e) => {
		// 선택된 행 객체를 얻음.
		//@ts-ignore
		var crow = RightSheet.getFocusedRow();
		if (crow) {
				//@ts-ignore
				var nrow = RightSheet.getNextRow(crow);
				if(nrow !=null){
					//@ts-ignore
					RightSheet.moveRow({row:nrow, next:crow , render:1});
					//@ts-ignore
					RightSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
				}
		}else{
			UIUtils.alert('선택된 셀이 없습니다.').then();
		}
	}

	//저장
	async function doSave() {	
		let param ={};
		//@ts-ignore
		var listRowsData = RightSheet.getDataRows(); 
		for(var i=0; i<listRowsData.length; i++){
			let limitAmount = listRowsData[i].LIMIT_AMOUNT;
			let amountRange = listRowsData[i].AMOUNT_RANGE;

			if(limitAmount === 0 || amountRange === ""){
				UIUtils.alert('한도금액 또는 범위 선택은 필수 항목입니다').then();
				return true;
			}
		}

		if(await UIUtils.confirm('저장하시겠습니까?')){
			//@ts-ignore
			let saveJson = RightSheet.getSaveJson({saveMode:0});

			saveJson.data?.forEach((item, index) => {
				//저장
				limitItem = {
					"PERSON_ID": item.PERSON_ID,
					"LIMIT_AMOUNT": item.LIMIT_AMOUNT,
					"AMOUNT_RANGE": item.AMOUNT_RANGE,
					"LIST_ORDER": item.LIST_ORDER,
					"ROW_STATUS":item.STATUS
				};
				console.log(" param :"+JSON.stringify(param));
				limitItems.push(limitItem);
				
			})

			//저장
			param = {
				"LIMIT_LIST": limitItems
			};

			//파라미터 전송
			const response:any = await CommonUtil.execute({
				url:'adm_4320_save',
				data: param
			}).then((response: any) => {
				if(response.ERR_CD =="9999"){
					UIUtils.alert(response.ERR_MSG).then();
					return;
				}else{
					UIUtils.alert('저장되었습니다.').then(() => {
						goList();
					});
					
				}
			}).catch(err => {
				CommonUtil.showAxiosError(err);
				return;
			});
		}
	}

	//목록으로
    const goList = () => {
        history.push({
            pathname: './adm4310',
            state: {data: receivedData}
        });
    }

	// init 
	React.useEffect(() => {
		
		//ib시트 생성
		ib.create();
		
		return () => {
		  // @ts-ignore
		  IBSheet.disposeAll(true);		  
		}
	},[])

	return (
		<PageContainer>
			<LayoutAside />
			<div className="fww-con">
				<ul className="fww-brd">
					<li><Link to="/admin">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">사용자관리</Link></li>
					<li><Link to="#">한도금액통제</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">최종결재자 한도금액 수정</h1>
					<div className="pt">
						<div className="row">
							<div className="col col-5 por mr30">
								<div className="hz-root hz-right hz-gap5 mt5 mb18">
									<div className="sl sl-sm ">
										<select name="divCd" id="divCd" className="" onChange={handleSelect} value={searchDivCd}>
											<option value="01">이름</option>
											<option value="02">아이디</option>
										</select>
									</div>
									<UIInput className={'hz-item tf tf-sm w262'} placeholder={'검색어 입력'} value={searchText} valueChanged={(value) => setSearchText(value)} onKeyEnter={(e) => activeEnter(e)}/>
									<Button color="pri" size="sm" onClick={()=>doSearchLeft('search')}>검색</Button>	
								</div>
								<div id ="LeftSheetDiv" className='ibsheet'>[D] IBSHEET 영역</div>
								<div className="adm_4320_btn_in_out">
									<button className="btn-out" onClick={rowDel}>삭제</button>
									<button className="btn-in" onClick={rowAdd}>추가</button>
								</div>
							</div>
							<div className="col col-5 ml30">
								<div className="hz-root hz-sb hz-bottom mb10">
									<h2 className="hz-item tx tx-hd3 mt0 mb12">최종결재자 한도금액</h2>
									<div className="hz-item hz-root hz-right hz-gap5">
									    {/* 테스트케이스 #473: [NCFMS-TS-80-TC-001] 결재함 리스트 저장 아이콘이 너무 하단에 위치하여 안보임 수정으로 위치변경*/}
										<Button color="pri-o" size="sm" onClick={doSave}>저장</Button>  
										<Button color="gray-o" size="sm" onClick={rowDel}>결재자 삭제 </Button>
										<button className="hz-item bt-up" type="button" onClick={rowMoveUp}>위로</button>
										<button className="hz-item bt-down" type="button" onClick={rowMoveDown}>아래로</button>
									</div>																			
								</div>
								<div id="RightSheetDiv" className='ibsheet'>[D] IBSHEET 영역</div>
								<div className="hz-root hz-right hz-gap5 mt10">
									{/* <Button color="pri-o" size="sm" onClick={doSave}>저장</Button> */}
									<Button color='gray-o' size="sm" onClick={goList}>목록</Button>
								</div>
							</div>
						</div>
					</div>						
				</main>
			</div>				
		</PageContainer>
	);
}
export default ContentsContainer;